import React from "react";
import PropTypes from "prop-types";

import ReactDatePicker from "react-datepicker";

import "./DateRange.scss";
// import "react-datepicker/dist/react-datepicker.css";
// import "bootstrap-daterangepicker/daterangepicker.css";

// TODO:KP: remove unused vaiable and add disbale and read only

const DatePicker = ({
  selected,
  onChange,
  placeholder,
  onBlur,
  isDisable,
  datePickerConfig,
  validationClass
}) => {
  const handleButtonClick = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  const configMapping = {
    format: "dateFormat",
    timeFormat: "timeFormat",
    timeIntervals: "timeIntervals",
    isMonthPicker: "showMonthYearPicker",
    displayInline: "inline",
    minDate: "minDate",
    maxDate: "maxDate",
    startDate: "openToDate",
    displayWeekNumber: "showWeekNumbers",
    selectWeekDates: "showWeekPicker",
    enableTodayBtn: "todayButton",
    highlightDates: "highlightDates",
    locale: "locale",
    calPropUpPosition: "popperPlacement",
    allowClear: "isClearable",
    showIcon: "showIcon",
    icon: "icon",
    holidays: "holidays",
    displayYearddl: "showYearDropdown",
    noOfYearinDdl: "yeardisplayinDropDown",
    noOfYear: "yearItemNumber",
    enableDdlScroll: "scrollableYearDropdown",
    inline: "inline",

    // Css Related Configuration
    className: "className", // class name for calender
    timeClassName: "timeClassName", // class name for Time Input
    calendarClassName: "calendarClassName", // class name for Menu
    dayClassName: "dayClassName", // class name for days

    // Excluding
    excludeDates: "excludeDates",
    excludeDateIntervals: "excludeDateIntervals", // Exclude date intervals

    // Range configuration
    isSingleRangePicker: "selectsRange",

    // Time Input configurations
    displayTimeInput: "showTimeInput",
    displayTimeSelect: "showTimeSelect",
    displayTimeSelectOnly: "showTimeSelectOnly",
    filteredTime: "filterTime",
    filteredDate: "filterDate",


    // Month configuration
    displayMonthPicker: "showMonthYearPicker",
    displayFullMonthName: "showFullMonthYearPicker",
    displayDoubleColumnMonthPicker: "showTwoColumnMonthYearPicker",
    displayFourColumnMonthPicker: "showFourColumnMonthYearPicker",
    displayMonthDropdown: "showMonthDropdown",
    displayShortMonthDropdown: "useShortMonthInDropdown",
    displayMonthYearDropdown: "showMonthYearDropdown",
    multiMonthsCount: "monthsShown",
    displayPreviousMonth: "showPreviousMonths",

    // Year configurations
    displayYearPicker: "showYearPicker",

    // Quarter configuration
    displayQuarterPicker: "showQuarterYearPicker",
    renderCustomHeader: "renderCustomHeader",
    renderDayContents: "renderDayContents",
    renderMonthContent: "renderMonthContent",
    renderQuarterContent: "renderQuarterContent",
    renderYearContent: "renderYearContent"
};

  const dynamicAttributes = Object.entries(configMapping).reduce((acc, [configKey, propKey]) => {
    if (datePickerConfig?.[configKey] !== undefined) {
        acc[propKey] = datePickerConfig[configKey];
    }
    return acc;
}, {});


  // const handleBlur = () => {
  //     if (onBlur) {
  //         onBlur()
  //     }
  // };

  return (
    <div className={`date-picker ${validationClass}`}>
      <ReactDatePicker
        placeholderText={placeholder}
        selected={selected}
        onChange={(e) => handleButtonClick(e)}
        onBlur={onBlur}
        autoComplete="off"
        disabled={isDisable}
        dateFormat={datePickerConfig?.dateFormat}
        timeFormat={datePickerConfig?.timeFormat}
        showTimeInput={datePickerConfig?.showTimeInput}
        showTimeSelect={datePickerConfig?.showTimeSelect}
        showTimeSelectOnly={datePickerConfig?.showTimeSelectOnly}
        timeIntervals={datePickerConfig?.timeIntervals}
        {...dynamicAttributes} 
      />
         {validationClass === "validation-error" && (
        <div className="validation-icon">
        </div>
      )}
    </div>
  );
};

DatePicker.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string.isRequired,
  datePickerConfig: PropTypes.object,
  onClick: PropTypes.func, // Use onClick for handling the button click
  cssClass: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

export default DatePicker;
